<template>
  <CommonHeader class="main_head_block">
    <template v-slot:header>

      <span class="module_heading" style="white-space: nowrap;width:auto;">
        Account Management
      </span>
      <div class="add_icon_container" @click="addNewVendor()" v-if="isUserAdmin || isSuperUser">
          <i
          class="fas fa-plus icon_add"
        ></i>
      </div>
      
      <i
        style="margin-left: 6px"
        class="fas fa-upload icon_one"
        @click="importClientExcel()"
      ></i>
      <i class="fas fa-download icon_two" @click="exportClientExcel()"></i>
      <div class="form-group col-md-2" style="margin: 0px; padding-left: 10px">
      </div>

      <div class="form-group col-md-2" style="margin: 0px">
      </div>

      <div class="form-group col-md-1" style="margin: 0px">
      </div>
      
      <div>
        <div class="head_search">
          <object
            data="assets/img/search.svg"
            style="height: 18px; width: 18px; margin-left: 5px"
          ></object>
        </div>
        <div class="ghost" @click="getFilterAccountList()"></div>
		<div class="adv_fil_wrap">
          <AccountFilter style="" @getList="getList" />
        </div>
        <div class="head_search_inp">
          <input
            type="search"
            id="search"
            class="search"
            v-model="searchFilterString"
            placeholder="Client Name"
            @keyup.enter="getFilterAccountList()"
            style="border: none; outline: none; padding: 7px 0px 5px 10px"
            autocomplete="off"
          />
        </div>
      </div>

      <ImportFilePopUp @getData="closeModal" />
      <DownloadFilesPopUp />
      <ExportClientData
        @closeExportClientPopUp="closeExportClientPopUp"
        :showSpinner="showSpinner"
        :isTimeOut="isTimeOut"
        :downloadLink="downloadLink"
      />
      <ImportClientData @closeImportClientPopUp="closeImportClientPopUp" />
    </template>
  </CommonHeader>
</template>

<script>
import AccountFilter from "@/components/account-management/AccountFilter.vue";
import Multiselect from "vue-multiselect";
import ImportFilePopUp from "@/components/account-management/ImportFilePopUp.vue";
import DownloadFilesPopUp from "./DownloadFilesPopUp.vue";
import ExportClientData from "./ExportClientData.vue";
import ImportClientData from "./ImportClientData.vue";
import Template from "../templates/Template.vue";
import CommonHeader from "@/components/CommonHeader.vue";
export default {
  name: "AccountsHeader",
  props: ["isExportExcel"],
  components: {
    AccountFilter,
    Multiselect,
    ImportFilePopUp,
    DownloadFilesPopUp,
    ExportClientData,
    ImportClientData,
    Template,
    CommonHeader,
  },
  data() {
    return {
      selectedClientList: {},
      go_contacts_list: [
        {
          id: "go_ops",
          name: "Go_OPs",
        },
        {
          id: "go_retail",
          name: "Go_Retail",
        },
        {
          id: "go_marketing",
          name: "Go_Marketing",
        },
      ],
      selectedContactType: [],
      isTimeOut: false,
      downloadLink: "",
      showSpinner: false,
      isUserAdmin: this.$store.state.isUserAdmin,
      isSuperUser: this.$store.state.auth.isSuperUser
    };
  },
  mounted() {
    if (
      this.$store.state.selectedClientFilter &&
      this.$store.state.clientList
    ) {
      this.selectedClientList = this.$store.state.clientList.filter(
        (e) => e.client_id == this.$store.state.selectedClientFilter
      );

      if (!this.selectedClientList.length) {
        this.$store.dispatch("getAccountClient").then((resp) => {
          this.selectedClientList = this.$store.state.clientList.filter(
            (e) => e.client_id == this.$store.state.selectedClientFilter
          );
        });
      }
    } else {
      this.selectedClientList = {
        client_id: "all",
        client_name: "All Clients",
      };
    }
  },
  computed: {
    syncCount: {
      get() {
        return this.$store.getters["accounts/getSyncCount"];
      },
    },
    clientList() {
      let data = this.$store.state.clientList.filter((e) => e.client_name);
      if (data && data.length && data[0].client_id != "all")
        data.unshift({
          id: "all",
          client_name: "All Clients",
          client_id: "all",
        });
      return data;
    },
    searchFilterString: {
      set(val) {
        if (!val) {
          this.$store.state.searchFilterString = val;
          this.$emit("filterList");
        } else {
          this.$store.state.searchFilterString = val;
        }
      },
      get() {
        return this.$store.state.searchFilterString;
      },
    },
  },
  methods: {
    closeImportClientPopUp() {
      //fetch account data call here
      //this.$emit("getAccountList")
      window.$("#importClientPopup").modal({
        hide: true,
      });
    },
    closeExportClientPopUp() {
      this.isTimeOut = false;
      this.downloadLink = "";
    },
    importClientExcel() {
      window.$("#importClientPopup").modal({
        show: true,
      });
    },
    exportClientExcel() {
      var vm = this;
      this.showSpinner = true;
      window.$("#exportClientPopup").modal({
        show: true,
      });
      this.$store
        .dispatch("accounts/getClientListForExport")
        .then((response) => {
          if (response && response.status == 200) {
            vm.isTimeOut = false;
            vm.downloadLink = response.data.Location;
            vm.showSpinner = false;
          } else {
            vm.isTimeOut = true;
            vm.showSpinner = false;
          }
        });
    },
    addNewVendor() {
      this.$router.push({
        path: "/addVendor",
      });
    },
    exportExcel() {
      $("#downloadFile").modal("show");
    },
    getFilterAccountList() {
      //sessionStorage.setItem("accounts:showPerPage",25);
      this.$store.state.currentPageNumber = 1;
      this.$emit("filterList");
    },
    getList() {
      this.$emit("filterList");
    },
    selectClient(val) {
      if (val.client_id == "all") {
        this.resetFilter();
      } else {
        this.$store.state.selectedClientFilter = val.client_id;
        this.$emit("getAccountList");
      }
    },
    resetFilter() {
      this.selectedClientList = {};
      this.$store.state.selectedClientFilter = "";
      this.$emit("getAccountList");
    },
    getContactTypeList(val) {
      let payload = {
        type: val.id,
      };
      this.$store.state.selectedAccountContactFilter = val.id;
      this.$emit("getAccountList");
    },
    resetContactFilter() {
      this.$store.state.selectedAccountContactFilter = "";
      this.selectedContactType = [];
      this.$emit("getAccountList");
    },
    importExcel() {
      window.$("#importFile").modal({
        show: true,
      });
    },
    closeModal() {
      $("#importFile").popover("hide");
    },
  },
};
</script>

<style lang="scss">
.icon-style {
  font-size: 30px;
  padding-left: 10px;
}
</style>
